import { render, staticRenderFns } from "./order-item-form-modal.vue?vue&type=template&id=4e5ab878&scoped=true"
import script from "./order-item-form-modal.vue?vue&type=script&lang=js"
export * from "./order-item-form-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5ab878",
  null
  
)

export default component.exports